import React from 'react';
import PropTypes from 'prop-types';

import './styles.css';

function Tabs({
  children, className, fill, classic, gray, primary, ...props
}) {
  return (
    <ul
      className={
                `Tabs ${
                primary ? 'Tabs--primary ' : ''
                }${fill ? 'Tabs--fill ' : ''
                }${gray ? 'Tabs--gray ' : ''
                }${classic ? 'Tabs--classic ' : 'Tabs--md '
                }${className || ''}`
            }
      {...props}
    >
      {children}
    </ul>
  );
}

Tabs.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  fill: PropTypes.bool,
};

export default Tabs;

export { default as Tab } from './Tab';
